// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"_5L-r7","stage":"_1AkUe","show":"_10UGr","closeButton":"_2_1hD","isPreviewFree":"_31jBJ","fullScreen":"_285at","restrict":"_2JpL0","custom":"_20MS4"};